import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface Card {
  cardBrand: string
  cardlast4: string
  expMonth: number
  expYear: number
  paymentMethodId: string
  bankName: string
  accountType: string
}

export interface CardsResponse extends AxiosResponse {
  data: Card[]
}

export interface GetPaymentCardsRequest extends Partial<AxiosRequestConfig> {
  params: {
    accountId?: string | null
  }
}

export function getPaymentCardsApi(
  params: GetPaymentCardsRequest,
  axiosInstance: AxiosInstance,
): Promise<CardsResponse> {
  return axiosInstance({
    ...params,
    method: "GET",
    url: "/payment/cards",
  }) as Promise<CardsResponse>
}

export interface GetCardDetailsByIdRequest extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string
    paymentMethodId: string
  }
}

export interface CardDetailsResponse extends AxiosResponse {
  data: { data: Card }
}

export function getCardDetailsByIdApi(
  { params }: GetCardDetailsByIdRequest,
  axiosInstance: AxiosInstance,
): Promise<CardDetailsResponse> {
  return axiosInstance({
    method: "get",
    url: `/payment/card/${params.paymentMethodId}?bookingNumber=${params.bookingNumber}`,
  }) as Promise<CardDetailsResponse>
}
